import { type TranslationTree } from '@/i18n/types';

export const messages = {
  status: {
    active: 'Ativo',
    paused: 'Pausado',
  },
  benefit: {
    trialDays: {
      one: '{{count}} dia a mais de teste',
      other: '{{count}} dias a mais de teste',
    },
  },
} satisfies TranslationTree;
